export default "__VITE_ASSET__DUH5oSSx__"